<div class="parts-inventory-graph">
  <div class="graph-header">
    <div class="chart-title-section">
      <div class="title-and-trend">
        <h3 class="graph-title">{{ title | transloco }}</h3>
      </div>
      <div class="header-actions">
        <span ngbDropdown class="filter-dropdown" [autoClose]="true">
          <button type="button" class="btn dropdown-toggle filter-btn" ngbDropdownToggle>
            {{ filterOptionLabelKeys[selectedFilter] | transloco }}
            <i class="ph ph-caret-down"></i>
          </button>
          <div ngbDropdownMenu>
            @for (option of filterOptions; track option) {
              <button class="dropdown-item" (click)="onFilterChange(option)" ngbDropdownItem>
                {{ filterOptionLabelKeys[option] | transloco }}
              </button>
            }
          </div>
        </span>
        <button class="btn-expand" type="button" [disabled]="isLoading" [class.btn-expand--placeholder]="isLoading" (click)="openModal()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.33333 3.33333H6.66667V2H2V6.66667H3.33333V3.33333ZM6.66667 12.6667H3.33333V9.33333H2V14H6.66667V12.6667ZM14 9.33333H12.6667V12.6667H9.33333V14H14V9.33333ZM12.6667 6.66667H14V2H9.33333V3.33333H12.6667V6.66667Z"
              fill="#9FA1A4" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="graph-body">
    @if (!isLoading && hasData()) {
      <div class="chart-and-legend">
        <div class="chart-wrapper">
          <app-donut-chart
            [data]="chartData"
            [width]="175"
            [height]="175"
            [innerRadiusRatio]="0.6"
            [variableArcWidths]="false"
            [showPercentageAlways]="true"
            (segmentHover)="onSegmentHover($event)">
          </app-donut-chart>

          <div class="center-text">
            <div class="center-label">{{ centerLabelKey | transloco }}</div>
            <div class="center-value" [class.hovered]="hoveredPercentage !== null || soleSegmentName !== null">
              {{ getCenterPercentage() }}
            </div>
          </div>
        </div>

        <div class="legend-container">
          @for (item of legendItems; track item.label) {
            <div class="legend-item" [class.highlighted]="hoveredSegmentName === item.label || soleSegmentName === item.label">
              <div class="legend-indicator" [style.background-color]="item.color"></div>
              <span class="legend-label" [title]="(item.labelKey ? (item.labelKey | transloco) : item.label) + ' ' + item.percentage + '%'">{{ item.labelKey ? (item.labelKey | transloco) : item.label }} {{ item.percentage }}%</span>
            </div>
          }
        </div>
      </div>
    } @else if (!isLoading && !hasData()) {
      <div class="d-flex align-items-center justify-content-center no-data">
        <app-empty-state></app-empty-state>
      </div>
    }
  </div>

  @if (isLoading) {
    <div class="card-loader">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>